/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useState, useEffect } from 'react';

/* -------------------------------------------------------------------------- */
/*                                  Hook                                      */
/* -------------------------------------------------------------------------- */
export const usePagination = (data: unknown[]) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const totalItems = data ? data.length : 0;
	const totalPages = Math.ceil(totalItems / pageSize);

	const startIndex = (currentPage - 1) * pageSize;
	const endIndex = startIndex + pageSize;

	const currentItems =
		data && Array.isArray(data)
			? data.slice(startIndex, endIndex)
			: [];

	const handlePageChange = (page: number) => {
		setCurrentPage(page);
	};

	const handlePageSizeChange = (_size: number) => {
		setPageSize(Number(_size));
		setCurrentPage(1);
	};

	useEffect(() => {
		if (
			currentItems &&
			Array.isArray(currentItems) &&
			currentItems.length == 0
		) {
			setCurrentPage(1);
		}
	}, [currentItems]);

	return {
		handlePageChange,
		handlePageSizeChange,
		totalPages,
		pageSize,
		setPageSize,
		total: totalItems,
		currentPage,
		currentItems,
	};
};
